import { Link } from "react-router";
import { Markdown } from "@client/components/Markdown";
import { useT } from "@client/i18n";
import type { PrepLecture } from "@content/prepSchema";
import { formatAnchor } from "../anchors";
import { AnchorLine } from "./AnchorLine";
import { BookBox } from "./BookBox";
import { Panel } from "./Panel";

type Session = Extract<PrepLecture, { kind: "problem-session" }>;

/** Results from the lectures this problem session reviews, each linked to where it was derived. */
export function RecapPanel({
  recaps,
  className,
}: {
  recaps: Session["recaps"];
  className?: string;
}) {
  const t = useT();
  return (
    <Panel title={t("teacher.prep.panel.recaps")} {...(className ? { className } : {})}>
      <BookBox>{`${t("teacher.prep.calibrated")} ${recaps.flatMap((r) => r.book.map(formatAnchor)).join("; ")}`}</BookBox>
      <ul className="space-y-3">
        {recaps.map((recap) => (
          <li
            key={recap.id}
            className="space-y-2 rounded-lg border border-ink-200 p-3 dark:border-ink-700"
          >
            <Markdown variant="compact">{recap.result}</Markdown>
            <AnchorLine book={recap.book} beyondBook={recap.beyondBook} />
            <Link
              to={`/teacher/prep/${encodeURIComponent(recap.derivedIn)}`}
              className="text-sm text-accent-700 hover:underline dark:text-accent-300"
            >
              {t("teacher.prep.derivedIn", { id: recap.derivedIn })}
            </Link>
          </li>
        ))}
      </ul>
    </Panel>
  );
}
